import { actionConst } from '../constants/execute-time.constants';
import { requestsConstants } from '../containers/Requests/requests.constants';
import { authHeader, authUploadHeader } from '../helpers/auth-header';
import { client } from './';
import { actions as newRequestActions } from '../containers/CreateRequest/new-request.actions';
import { calendarActions } from '../actions/calendar.actions';
import moment from 'moment';

const url = '/Request';

const actions = {
	openExecuteTimeModal,
	closeExecuteTimeModal,
	openExecuterModal,
	closeExecuterModal,
	openMasterModal,
	closeMasterModal,
	openCalendarModal,
	closeCalendarModal,
	postExecuteTime,
	postExecuter,
	postMaster,
	postCalendar,
	deleteCalendar,
	setHoldStatus,
};


function postExecuter(value) {

	let rurl = url + '/set_executer/' + value.request;

	return (dispatch, getState) => {

		client.put(rurl, value.executerId, { headers: authHeader() })
			.then((response) => {

				const rl = getState().requestsStore.requests.slice()
				const el = getState().newRequestStore.listExecuter
				const ri = rl.findIndex(el => '' + el.id === value.request)
				rl[ri].executer = el.find(el => '' + el.id === value.executerId)

				dispatch({
					type: requestsConstants.SET_REQUEST_EXECUTER,
					payload: new Promise(resolve => { resolve({ data: rl }) }),
				})

			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function postMaster(value) {
	let rurl = url + '/set_master/' + value.request;
	return (dispatch, getState) => {
		client.put(rurl, value.masterId, { headers: authHeader() })
			.then((response) => {
				const rl = getState().requestsStore.requests.slice()
				const el = getState().newRequestStore.listWorker
				const ri = rl.findIndex(el => '' + el.id === value.request)
				rl[ri].master = el.find(el => '' + el.id === value.masterId)
				dispatch({
					type: requestsConstants.SET_REQUEST_MASTER,
					payload: new Promise(resolve => { resolve({ data: rl }) }),
				})
			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function deleteCalendar(value) {

	let rurl = url + '/drop_task/' + value.eventId;

	return (dispatch, getState) => {

		client.delete(rurl, { headers: authHeader() })
			.then((response) => {

				const rl = getState().requestsStore.requests.slice();
				const ri = rl.findIndex(el => el.id == value.request);
				rl[ri].taskId = null;
				rl[ri].taskStart = null;
				rl[ri].taskEnd = null;

				dispatch({
					type: requestsConstants.SET_REQUEST_MASTER,
					payload: new Promise(resolve => { resolve({ data: rl }) }),
				})

				if(value.cview && value.cdate) {
					console.log('calendarActions.fetchRequests')
					dispatch(calendarActions.fetchRequests(value.cview, value.cdate))
				}

			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});
	}
}

function updateCalendarEvent(id, data) {

	let rurl = url + '/edit_task/' + id;

	return client.put(rurl, data, { headers: authHeader() })
}

function postCalendar(value) {

	return (dispatch, getState) => {

		if (value.executeTimeEnd.hour() == 0 && value.executeTimeEnd.minute() == 0) {
			value.executeTimeEnd.set({ 'hour': 23, 'minute': 59, 'second': 59 })
		}

		const _fromDate = value.executeDate.format('YYYY-MM-DD') + ' ' + value.executeTimeStart.format('HH:mm')
		const _toDate = value.executeDate.format('YYYY-MM-DD') + ' ' + value.executeTimeEnd.format('HH:mm')

		const calendarEvent = {
			requestId: value.request,
			workerId: value.executerId,
			fromDate: moment(_fromDate).utc().format(),
			toDate: moment(_toDate).utc().format()
		}

		const eventFunc = value.eventId ? updateCalendarEvent(value.eventId, calendarEvent) 
			: newRequestActions.postCalendarEvent(calendarEvent)

		eventFunc.then((response) => {

				const rl = getState().requestsStore.requests.slice()
				const ri = rl.findIndex(el => el.id == value.request)
				rl[ri].taskId = value.eventId || +response.data
				rl[ri].taskStart = moment(_fromDate).utc().format();
				rl[ri].taskEnd = moment(_toDate).utc().format();

				dispatch({
					type: requestsConstants.SET_REQUEST_EXECUTE_TIME,
					payload: new Promise(resolve => { resolve({ data: rl }) }),
				})

				if(value.cview && value.cdate) {
					dispatch(calendarActions.fetchRequests(value.cview, value.cdate))
				}

			})
			.catch(function (error) {
				console.log(error);
				dispatch({
					type: requestsConstants.POST_ERROR,
					payload: error
				})
			});

			//? updateCalendarEvent(value.eventId, calendarEvent) : 

		}
}

	function postExecuteTime(value) {

		let rurl = url + '/set_execute_date/' + value.request;

		return (dispatch, getState) => {
			const executeDateTime = moment(value.executeDate.format('YYYY-MM-DD') + value.executeTime.format('[T]HH:mm:[59]'))
			const executeDateTimeUtcStr = executeDateTime.clone().utc().format()
			const data = { executeDate: executeDateTimeUtcStr, note: value.comment }

			client.put(rurl, data, { headers: authUploadHeader() })
				.then((response) => {
					const rl = getState().requestsStore.requests.slice();
					const ri = rl.findIndex(el => '' + el.id === ''+value.request);
					rl[ri].executeTime = executeDateTime
					rl[ri].executeDateTime = executeDateTime
					dispatch({
						type: requestsConstants.SET_REQUEST_EXECUTE_TIME,
						payload: new Promise(resolve => { resolve({ data: rl }) }),
					})

					//const { io } = getState().socketioStore;
					//if(io) {
					//	io.emit("set execute time", rl[ri] )
					//}
				})
				.catch(function (error) {
					console.log(error);
					dispatch({
						type: requestsConstants.POST_ERROR,
						payload: error
					})
				});
		}
	}

	// Покос травы зимой	
	function setHoldStatus(value) {

		let rurl = '/Request/hold/' + value.request;

		return (dispatch, getState) => {
			const executeDateTime = moment(value.executeDate.format('YYYY-MM-DD') + value.executeTime.format('[T]HH:mm:[59]'))
			const executeDateTimeUtcStr = executeDateTime.clone().utc().format()
			const data = { executeDate: executeDateTimeUtcStr, note: value.comment }

			client.put(rurl, data, { headers: authUploadHeader() })
				.then((response) => {
					const rl = getState().requestsStore.requests.slice();
					const ri = rl.findIndex(el => el.id === value.request);
					rl[ri].status = value.statusDescr;
					rl[ri].statusId = +value.statusId;
					rl[ri].executeTime = executeDateTime;
					dispatch({
						type: requestsConstants.SET_REQUEST_EXECUTE_TIME,
						payload: new Promise(resolve => { resolve({ data: rl }) }),
					})

					const { io } = getState().socketioStore;
					if(io) {
						io.emit("set hold status", rl[ri] )
					}
				})
				.catch(function (error) {
					console.log(error);
					dispatch({
						type: requestsConstants.POST_ERROR,
						payload: error
					})
				});
		}
	}

	function openExecuteTimeModal(v) {
		return dispatch => {
			dispatch({
				type: actionConst.OPEN_EXECUTE_TIME_MODAL,
				payload: v,
			})
		}
	}

	function openCalendarModal(v) {
		return dispatch => {
			dispatch({
				type: actionConst.OPEN_CALENDAR_MODAL,
				payload: v,
			})
		}
	}

	function closeExecuteTimeModal() {
		return dispatch => {
			dispatch({
				type: actionConst.CLOSE_EXECUTE_TIME_MODAL
			})
		}
	}

	function closeCalendarModal() {
		return dispatch => {
			dispatch({
				type: actionConst.CLOSE_CALENDAR_MODAL
			})
		}
	}

	function openExecuterModal(r, e ) {
		return dispatch => {
			dispatch({
				type: actionConst.OPEN_EXECUTER_MODAL,
//				payload: { r, e, p: {houseId: b, serviceId: s} },
				payload: { r, e },
			})
		}
	}

	function openMasterModal(r, e) {
		return dispatch => {
			dispatch({
				type: actionConst.OPEN_MASTER_MODAL,
//				payload: { r, e, p: {houseId: b, serviceId: s} },
				payload: { r, e },
			})
		}
	}


	function closeExecuterModal() {
		return dispatch => {
			dispatch({
				type: actionConst.CLOSE_EXECUTER_MODAL
			})
		}
	}


	function closeMasterModal() {
		return dispatch => {
			dispatch({
				type: actionConst.CLOSE_MASTER_MODAL
			})
		}
	}

	export default actions;